module.exports = __webpack_public_path__ + "static/media/md-sync.a0fb5f7a.svg";